var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultProfileImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dbdbdb"
    },
    d: "M0 0h1000v1000H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.76 989.07C886.32 972 825.32 928 792.32 918c-31.49-9.54-62.6-20.39-88.58-32.67l.4-.33-4-6c1.28-1.23 1.55-2 .6-2.26-9.72-2.43-25.62-92.21-25.62-92.21a11.5 11.5 0 0 0-.14 1.66v-1.66c-16-3.74-31-7-46.47-9.87-4.67-31-8.44-64.91-7.47-79.61 15.94-18.72 30.17-38.62 35.07-54.4 11.69-37.63 15.78-59.15 15.78-59.15a24.39 24.39 0 0 0 17.55-8.7c7-8.7 8.78-64.37 14-80s8.77-41.75-8.79-40a18.48 18.48 0 0 0-9 3.56c1.76-11.57 21.07-40.83 21.07-40.83s16.23-98.3 13-104.86 16.22-14.74-13-68.81-159-132.71-212.58-139.27-128.2 0-159 85.2c0 0-81.14 18-92.5 103.22s51.93 145.82 51.93 172v.32c-3.45-9.07-7.26-16.35-10.86-17.53-10.53-3.48-29.85-3.48-26.34 38.27s7.78 9.43 22.83 87c8.78 45.23 24.59 10.44 24.59 10.44s14.72 72 49.88 123.62c.11 18 .41 46.49 1.21 69.41q-22.44 4.26-44.93 10v1.91a8.23 8.23 0 0 0-.21-1.08s-15.32 90-25.13 92.49c-1.35.35-.25 1.77 2.75 4l-11.32 8.58a92.17 92.17 0 0 1-16.29 9.87l-29.92 14.12-24.51 6.35A125.27 125.27 0 0 0 151 951.7l-50.32 48.3h798.64s.28-1.13-4.56-10.93Z",
    style: {
      fill: "#babab9"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfileImage);
export default __webpack_public_path__ + "static/media/default-profile-image.f9591435f791be6a143ae9b78a9e7a00.svg";
export { ForwardRef as ReactComponent };